import { string } from "efform";

const CurrenciesCreateScheme = {
  title: string().required("Обязательное поле"),
  code: string().required("Обязательное поле")
}

export default CurrenciesCreateScheme